import commonActionCreators from "../../../shared/store/common/action-creators";
import ApiService from "../../../shared/services/api-service";
import riskAlertsCommitTypes from "./commit-types";

const riskAlertsActionCreators = {
  fetchRiskAlerts() {
    return async (dispatch) => {
      dispatch(this.setIsLoading('fetchRiskAlerts'));
      const data = await ApiService.get('/api/v1/risk-alerts')
        .then(response => response.data)
        .catch(error => ({error}));
      dispatch(this.setIsLoading('fetchRiskAlerts'));
      if (data.error) {
        dispatch(commonActionCreators.handleApiError(data.error));
      } else {
        dispatch(this.fetchRiskAlertsSuccess(data.data));
      }
    };
  },
  setIsLoading(isLoading) {
    return {
      isLoading,
      type: riskAlertsCommitTypes.SET_RISK_ALERTS_IS_LOADING
    }
  },
  fetchRiskAlertsSuccess(riskAlerts) {
    return {
      riskAlerts,
      type: riskAlertsCommitTypes.PUSH_RISK_ALERTS
    }
  }
};

export default riskAlertsActionCreators;